import React, { useCallback } from 'react';

import { Col, Row } from 'antd';

import ShiftCardOption from '@src/components/Cards/shifts/ShiftCardOption';
import { SHIFT_TYPES } from '@src/packages/shifts/constants';
import { ALLOWED_ROLES } from '@src/packages/utils';
import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';
import IntlMessages from '@src/util/IntlMessages';

import styles from '../styles.module.less';

const JOURNEY_TYPE_OPTIONS = [
  {
    id: 'fixed',
    titleId: 'workJourney.fixedJourney',
    descriptionId: 'workJourney.fixedJourneyDescription',
    actionLabelId: 'workJourney.create.typeAction.fixed',
    icon: 'schedule',
    value: SHIFT_TYPES.FIXED,
  },
  {
    id: 'part-time',
    titleId: 'workJourney.partTimeJourney',
    descriptionId: 'workJourney.partTimeJourneyDescription',
    actionLabelId: 'workJourney.create.typeAction.partTime',
    icon: 'access_time',
    value: SHIFT_TYPES.PART_TIME,
  },
  {
    id: 'shift',
    titleId: 'workJourney.shiftJourney',
    descriptionId: 'workJourney.shiftJourneyDescription',
    actionLabelId: 'workJourney.create.typeAction.shift',
    icon: 'rotate_right',
    value: SHIFT_TYPES.SHIFT_WORK,
  },
  {
    id: 'cycle',
    titleId: 'workJourney.cycleJourney',
    descriptionId: 'workJourney.cycleJourneyDescription',
    actionLabelId: 'workJourney.create.typeAction.cycle',
    icon: 'loop',
    value: SHIFT_TYPES.CYCLE,
  },
  {
    id: 'bi-weekly',
    titleId: 'workJourney.biWeeklyJourney',
    descriptionId: 'workJourney.biWeeklyJourneyDescription',
    actionLabelId: 'workJourney.create.typeAction.biWeekly',
    icon: 'calendar_view_week',
    value: SHIFT_TYPES.BIWEEKLY,
  },
] as const;

const JourneyType = () => {
  const { setWorkJourneyType, setWorkJourneyForm } = useWorkJourneyContext();

  const handleSelectType = useCallback(
    (value: string) => {
      setWorkJourneyType(value);
      setWorkJourneyForm(prev => ({ ...prev, type: value }));
    },
    [setWorkJourneyType, setWorkJourneyForm],
  );

  return (
    <div className={styles.journeyTypesContainer}>
      <p className={styles.typeSelectionHint}>
        <IntlMessages id="workJourney.create.typeSelectionHint" />
      </p>
      <Row gutter={[24, 24]}>
        {JOURNEY_TYPE_OPTIONS.map(option => (
          <Col key={option.id} xs={24} sm={12} lg={12}>
            <ShiftCardOption
              icon={option.icon}
              title={<IntlMessages id={option.titleId} />}
              description={<IntlMessages id={option.descriptionId} />}
              actionLabel={<IntlMessages id={option.actionLabelId} />}
              allowedRoles={ALLOWED_ROLES.ORGANIZATIONS.WORK_JOURNEY.CREATE}
              onCreate={() => handleSelectType(option.value)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default JourneyType;
